/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitionWithRelations } from '../../models/exhibition-with-relations';

export interface InventoryGetExhibition$Params {
  id: string;
  inventoryId: string;
}

export function inventoryGetExhibition(http: HttpClient, rootUrl: string, params: InventoryGetExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitionWithRelations>> {
  const rb = new RequestBuilder(rootUrl, inventoryGetExhibition.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExhibitionWithRelations>;
    })
  );
}

inventoryGetExhibition.PATH = '/inventory/exhibitions/{id}';
